import { render } from "./LandsHold.vue?vue&type=template&id=992b2116&ts=true"
import script from "./LandsHold.vue?vue&type=script&lang=ts"
export * from "./LandsHold.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__